import StaffAttendanceSubcontractorSelect from "./staff-attendance-subcontractor-select";
import StaffAuditSubcontractorSelect from "./staff-audit-subcontractor-select";
import StaffWorkerRolesField from "./staff-worker-roles-field";


const StaffManagementFormFields = {
    AttendanceSubcontractorSelect: StaffAttendanceSubcontractorSelect,
    AuditSubcontractorSelect: StaffAuditSubcontractorSelect,
    WorkerRoles: StaffWorkerRolesField,
};

export default StaffManagementFormFields;
